import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import products from "../data/products";
import "../../App.css";

const ProductSection = () => {
  const navigate = useNavigate();

  const leftVariant = { hidden: { opacity: 0, x: -80 }, visible: { opacity: 1, x: 0 } };
  const bottomVariant = { hidden: { opacity: 0, y: 80 }, visible: { opacity: 1, y: 0 } };
  const rightVariant = { hidden: { opacity: 0, x: 80 }, visible: { opacity: 1, x: 0 } };

  return (
  <section style={{ background: "linear-gradient(135deg, #fff,  #cfa4dcff)" }}
  className="py-5">
      <Container className="mt-4 mb-4">
        <h1
          className="text-center mt-4 fw-bold mb-5"
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontSize: "2.8rem",
            letterSpacing: "0.5px",
            lineHeight: "1.3",
            textTransform: "uppercase",
            color: "black",
          }}
        >
          Our Products
        </h1>

        {Array.from({ length: Math.ceil(products.length / 3) }, (_, rowIndex) => (
          <Row key={rowIndex} className="mb-4">
            {products
              .slice(rowIndex * 3, rowIndex * 3 + 3)
              .map((product, colIndex) => {
                const variants =
                  colIndex === 0
                    ? leftVariant
                    : colIndex === 1
                    ? bottomVariant
                    : rightVariant;

                return (
                  <Col md={4} key={product.id}>
                    <motion.div
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ amount: 0.3 }}
                      transition={{ duration: 0.6, ease: "easeOut", delay: colIndex * 0.3 }}
                      variants={variants}
                    >
                      <Card
                        className="shadow-lg rounded-4 m-3 overflow-hidden"
                        style={{
                          height: "400px",
                          backgroundColor: "#1E1E1E",
                          color: "#fff",
                          cursor: "pointer",
                          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.8)",
                        }}
                        // onClick={() => navigate(`/portfolio-details/${product.id}`)}

                      >
                        <Card.Body className="p-0 d-flex flex-column">
                          <div className="p-3">
                            <h5 className="fw-bold mb-2" style={{ letterSpacing: "0.5px" }}>
                              {product.title}
                            </h5>
                            <p
                              className="small mb-1 mt-2"
                              style={{ lineHeight: "1.4", letterSpacing: "0.3px" }}
                            >
                              {product.text}
                            </p>
                          </div>

                          <div style={{ flex: 1, display: "flex" }}>
                            <img
                              src={product.video}
                              className="w-100 h-110"
                              style={{ objectFit: "cover" }}
                              autoPlay
                              loop
                              muted
                              playsInline
                            />
                          </div>
                        </Card.Body>
                      </Card>
                    </motion.div>
                  </Col>
                );
              })}
          </Row>
        ))}
      </Container>
    </section>
  );
};

export default ProductSection;
